// extracted by mini-css-extract-plugin
module.exports = {"container":"HowWeWorkItem_container__WBAeW","imageWrapper":"HowWeWorkItem_imageWrapper__a9pr7","heading":"HowWeWorkItem_heading__z6SM5","richtext":"HowWeWorkItem_richtext__0_A9M"};